export const daysOptions = [
  {
    value: 'Mon',
    label: 'Понедельник'
  },
  {
    value: 'Tu',
    label: 'Вторник'
  },
  {
    value: 'Wed',
    label: 'Среда'
  },
  {
    value: 'Th',
    label: 'Четверг'
  },
  {
    value: 'Fri',
    label: 'Пятница'
  },
  {
    value: 'Sat',
    label: 'Суббота'
  },
  {
    value: 'Sun',
    label: 'Воскресенье'
  },
]
